// 表紙コンポーネントで使用する共通定数

// 共通のサイズ定義
export const COVER_COMMON_SIZES = {
  // プレビュー表示の最大幅（px）
  previewWidth: 282,

  // 塗り足し幅（px）
  bleedMargin: 35,

  // A5スタンダードのページ数96ページ。
  // 表紙幅（1748px + 塗り足し35px = 1783px）
  coverWidth: 1783,
  // 表紙全体の高さ（2481px + 塗り足し35px * 2 = 2551px）
  coverHeight: 2551,

  // セーフエリアの幅（塗り足しなし：ユーザーが見る範囲）
  safeCoverWidth: 1748,

  // セーフエリアの高さ（塗り足しなし：ユーザーが見る範囲）
  safeCoverHeight: 2481
};

// Simpleの最小画像サイズ（塗り足しあり）
export const SIMPLE_MIN_IMAGE_SIZE = {
  width: 1783,
  height: 1733
};

// Pastelの最小画像サイズ
export const PASTEL_MIN_IMAGE_SIZE = {
  width: 1514,
  height: 1532
};
